import { Text } from "@/components";

export const Info = () => {
  return (
    <div className="container mx-auto">
      <div className="mx-auto max-w-screen-xl flex flex-col items-center gap-10">
        <Text.Heading className="text-white md:px-[100px] text-center">
          <span>
            Plans &&nbsp;
            <span className="text-secondary">Pricing</span>
          </span>
        </Text.Heading>

        <div className="text-2xl text-center">
          Plans are based upon funds raised so we can ensure our pricing
          <br />
          fits into every startup’s budget. To get started select how much
          <br />
          money your startup has raised
        </div>
      </div>
    </div>
  );
};
